var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 5.89961H13.41L16.35 2.95961C16.55 2.75961 16.55 2.44961 16.35 2.24961C16.15 2.04961 15.84 2.04961 15.64 2.24961L12 5.88961L8.36 2.24961C8.16 2.04961 7.85 2.04961 7.65 2.24961C7.45 2.44961 7.45 2.75961 7.65 2.95961L10.59 5.89961H3C1.9 5.89961 1 6.78961 1 7.89961V19.8996C1 20.9996 1.9 21.8996 3 21.8996H21C22.1 21.8996 23 20.9996 23 19.8996V7.89961C23 6.78961 22.1 5.89961 21 5.89961ZM10.5 17.0496L14.48 14.7696C15.15 14.3896 15.15 13.4196 14.48 13.0296L10.5 10.7496C9.83 10.3696 9 10.8596 9 11.6196V16.1696C9 16.9396 9.83 17.4296 10.5 17.0496ZM4 19.8996H20C20.55 19.8996 21 19.4496 21 18.8996V8.89961C21 8.34961 20.55 7.89961 20 7.89961H4C3.45 7.89961 3 8.34961 3 8.89961V18.8996C3 19.4496 3.45 19.8996 4 19.8996Z",
    fill: "#1B1B1B",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame3);
export default __webpack_public_path__ + "static/media/frame3.26fe523c79293debc7c8d739e3287135.svg";
export { ForwardRef as ReactComponent };